import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_API_URL } from "../Constant";

export const FlipbookDataSlice = createSlice({
  name: "FlipbookData",
  initialState: {
    flipbookData: [],
    error: false,
    loader: false,
  },
  reducers: {
    setFlipbookData: (state, action) => {
      state.flipbookData = action.payload;
    },
    setError: (state) => {
      state.error = true;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
  },
});

export const { setFlipbookData, setError, setLoader } =
  FlipbookDataSlice.actions;
export default FlipbookDataSlice.reducer;

export function getCourseData(courseName) {
  return (dispatch) => {
    dispatch(setLoader(true));
    axios
      .post(
        `${BASE_API_URL}/api/getCourseData`,
        {
          courseName: courseName,
        },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        dispatch(setFlipbookData(res.data));
        dispatch(setLoader(false));
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
      });
  };
}
